<template>

    <section id="principal">

        <!--

        <v-parallax dark :src="require('@/assets/img/fondoAzul.jpg')" :max-width="tamaño_sectionW" :height="tamaño_sectionH" >

        -->
            <v-container fluid  class="pt-6" >
            
                <v-row align="center" justify="center">

                    <v-col cols="12"  sm="12" md="4" class="pt-12 px-4">
                        <h1>Desarrollo de proyectos web  a medida</h1>
                        <h3>Stack de Desarrollo PEVN</h3> <br>
                        
                        <v-img :src="require('@/assets/img/home/home_stack.webp')" />
                    </v-col>


                    <v-col cols="12"  sm="12" md="7">

                        <v-carousel show-arrows="hover"  cycle   hide-delimiter-background   height="auto" progress="primary" class="pt-12" >
                            <!--   :interval="10000"
                            <v-carousel-item v-for="(item, i) in Datos" :key="i" cover :src="require('@/assets/img/home/slider_vue.png')"> 
                                <div class="d-flex  fondoTexto flex-column fill-height align-self-end justify-center align-center display-1">
                                    <div  class="text-h2 px-4">
                                        {{item.titulo  }} <br>
                                        <span class="text-h4"> {{item.descripcion  }}</span>
                                    </div>
                                </div>  
                        </v-carousel-item> -->
                        
                        <v-carousel-item cover :src="require('@/assets/img/home/slider_vue.png')"> 
                                <div class="d-flex   flex-column fill-height align-self-end justify-center">
                                    <div  class="px-4">
                                        <h1>{{ Datos[0].titulo  }}</h1>
                                         <br>
                                         <h2>{{Datos[0].descripcion  }}</h2>
                                    </div>
                                </div>  
                        </v-carousel-item> 

                        <v-carousel-item cover :src="require('@/assets/img/home/slider_postgres.png')"> 
                                <div class="d-flex  fondoTexto flex-column fill-height align-self-end justify-center align-center">
                                    <div  class="px-4">
                                        <h1>{{ Datos[1].titulo  }}</h1>
                                         <br>
                                         <h2>{{Datos[1].descripcion  }}</h2>
                                     </div>
                                </div>  
                        </v-carousel-item> 

                        <v-carousel-item cover :src="require('@/assets/img/home/slider_node.png')"> 
                                <div class="d-flex  fondoTexto flex-column fill-height align-self-end justify-center align-center">
                                    <div  class="px-4">
                                        <h1>{{ Datos[2].titulo  }}</h1>
                                         <br>
                                         <h2>{{Datos[2].descripcion  }}</h2>
                                     </div>
                                </div>  
                        </v-carousel-item> 

                        <v-carousel-item cover :src="require('@/assets/img/home/slider_vue.png')"> 
                                <div class="d-flex  fondoTexto flex-column fill-height align-self-end justify-center align-center">
                                    <div  class="px-4">
                                        <h1>{{ Datos[3].titulo  }}</h1>
                                         <br>
                                         <h2>{{Datos[3].descripcion  }}</h2>
                                     </div>
                                </div>  
                        </v-carousel-item> 
                        
                      
                    </v-carousel>

                        <!--
                        <v-carousel show-arrows="hover"  cycle   :interval="10000" hide-delimiter-background  progress="primary" class="pt-12">
                            <v-carousel-item v-for="(item, i) in datos" :key="i" cover :src="item.img"> 
                                <div class="d-flex  fondoTexto flex-column fill-height align-self-end justify-center align-center display-1">
                                    <div  class="text-h2 px-4">
                                        {{item.titulo  }} <br>
                                        <span class="text-h4"> {{item.descripcion  }}</span>
                                    </div>
                                </div>
                        </v-carousel-item> 
                    </v-carousel>          -->   
                     </v-col>
                </v-row>
                 

                
            </v-container>      

            <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" 
                @reloadComp="reloadComp" @close="estadoComponente=false" >
            </component>
            
            <!--
            </v-parallax>
            -->


        <div class="svg-border-waves text-white">
        <v-img :src="require('@/assets/img/borderWaves.svg')" />
      </div>


        

    </section>
</template>


<script>
    import axios,  { API_URL } from '@/helpers/axios'
    import { mapState, mapMutations} from 'vuex'
    // import CatalogoGaleriaComp from './catalogue/catalogoGaleria.vue'
    
    export default {

        name: "Principal",
        
        components: {
        //    CatalogoGaleriaComp
        },



        mounted() {

            console.log(process.env.VUE_APP_API_URL)
            console.log(process.env.VUE_APP_PRUBA)
            console.log(process.env)
            console.log(`SERVIDOR: ${window.location.hostname}`)

            this.loadMain()
        },



        data: () => ({
            test: false,
            rutaServer: API_URL,

            tamaño_sectionW: "",
            tamaño_sectionH: "",

            
            Datos:[

               {
                    img: "https://cdn.vuetifyjs.com/images/cards/hotel.jpg",
                    titulo: "PEVN",
                    descripcion: "El stack de desarrollo se refiere a las tecnologías, herramientas y lenguajes de programación que se utilizan para crear una aplicación o sitio web. ",
                },

                {
                    img: "https://cdn.vuetifyjs.com/images/cards/docks.jpg",
                    titulo: "Postgresql",
                    descripcion: "Sistema de gestión de bases de datos relacional de código abierto ampliamente reconocido por su robustez, escalabilidad y características avanzadas.",
                },

                {
                    img: "https://cdn.vuetifyjs.com/images/cards/docks.jpg",
                    titulo: "NODE",
                    descripcion: "Node.js es un entorno de ejecución de un solo hilo, de código abierto y multiplataforma para crear aplicaciones de red y del lado del servidor rápidas y escalables,  basado en el motor V8 de Google ",
                },
                /*
                {
                    img: "https://cdn.vuetifyjs.com/images/cards/hotel.jpg",
                    titulo: "Express",
                    descripcion: "Framework de código abierto para desarrollar aplicaciones web con Node.js",
                }, */

                {
                    img: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
                    titulo: "Vue",
                    descripcion: "Vue es un framework progresivo de JavaScript para crear interfaces de usuario (UI) y aplicaciones de una sola página (SPA)",
                },

            
            ],
           

            compName:"",
            estadoComponente:   false,
            parametroComp : {},

        }),


        created(){
            var height = window.screen.height;
            var width = window.screen.width;

            this.tamaño_sectionH = height - 150
            this.tamaño_sectionW = width
            //this.tamaño_section = 'height:' + height+'px'
            //alert(this.tamaño_section)
            //$('#principal').height(height);

        },


        watch: {
            
            
        },

        computed: {
            ...mapState("eventMenu", ["categoria",  "linea", "searchProduct"]),  
        },


        methods: {

             //  ------- MENSAJE DE SISTEMA  --------
             ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////
            
            async loadMain(){
                // this.loadCatalogue()
                
            },


            
            ViewImage(items) {
                // this.parametroConfig = item
                this.parametroComp = {items}
                console.log(`ViewImagen ${items}`)
                
                this.compName  = 'CatalogoGaleriaComp';
                this.estadoComponente  = true            
            },


            reloadComp(procedencia){
                // console.debug(procedencia)                
                // this.loadMain()
                this.estadoComponente=false
            },

            
        },
    };
</script>




<style>



    .svg-border-waves .v-image {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3rem;
        width: 100%;
        overflow: hidden;
        }

    #principal {
        z-index: 0;
    }

    .svg-border-waves img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin-bottom: -2px;
        z-index: -1;
    }

    .card {
        min-height: 300px;
        padding: 10px;
        transition: 0.5s ease-out;
    }

    .card .v-image {
        margin-bottom: 15px;
        transition: 0.75s;
    }

    .card h1 {
        margin-bottom: 10px;
    }

    .zoom-efect {
        transform: scale(1.1);
    }


</style>


<style scope>
    section {
        position: relative;
        min-height: 100vh;
    }


    /*! Full-screen */
    .mbr-fullscreen .mbr-overlay {
    min-height: 100vh; }

    .mbr-fullscreen {
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    align-items: center;
    -webkit-align-items: center;
    min-height: 100vh;
    padding-top: 3rem;
    padding-bottom: 3rem; }


    /*.zoom-efect.medida_col_princ{
        margin-bottom: 400px;
    }*/


    .pantalla{
       /* position: absolute; /*position: fixed;*/
        top: 0;
        left: 0;
        height: 100vh;
    }


</style>

